import { ROOT_COMPANY_ID } from './company'

export const CHAT_BOT_DOAMIN_MAP = {
  [ROOT_COMPANY_ID.HENKEL]: 'chatbot-henkel',
  [ROOT_COMPANY_ID.HSBC]: 'chatbot-hsbc',
  [ROOT_COMPANY_ID.DIAGEO]: 'chatbot-diageo'
}
export const CHAT_BOT_COOKIE_USER_UUID_KEY_MAP = {
  [ROOT_COMPANY_ID.HENKEL]: 'user_id',
  [ROOT_COMPANY_ID.HSBC]: 'hsbc_user_id',
  [ROOT_COMPANY_ID.DIAGEO]: 'diageo_user_id'
}
